module.exports = __webpack_public_path__ + "fonts/MyriadPro-Bold.bfc84fcb.otf";